import React, { memo } from "react";
import useLoginForm from "./index.hooks";
import { AppButton } from "components";
import { TextField, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

type LoginFormProps = {};

const LoginForm = ({}: LoginFormProps) => {
  const {
    styles,
    handleSubmit,
    onSubmit,
    register,
    fields,
    t,
    isSigningIn,
  } = useLoginForm();

  return (
    <div className={styles.formContainer}>
      <Typography className={styles.formTitle}>Login</Typography>
      <form onSubmit={onSubmit}>
        {fields.map((elm) => (
          <TextField
            key={elm.name}
            variant="outlined"
            label={elm.label}
            name={elm.name}
            type={elm.type}
            className={styles.inputField}
            inputRef={register}
            fullWidth
          />
        ))}
        <AppButton
          color="primary"
          type="submit"
          variant="contained"
          fullWidth
          loading={isSigningIn}
          disabled={isSigningIn}
        >
          {t("Entra!")}
        </AppButton>
      </form>
      <Typography className={styles.member}>
        {t("Non hai ancora un account?")}{" "}
        <Link to="/signup/"> {t("Registrati")} </Link>
      </Typography>
    </div>
  );
};

export default memo(LoginForm);
